import { createFileRoute, Navigate } from '@tanstack/react-router';
import { pageTitle } from '@/utils/pageTitle';
import { useAuth } from '@/contexts/AuthContext';
import { CashRegisterPage } from '@/components/Pages/CashRegister/CashRegisterPage';

export const Route = createFileRoute('/_protected/cash-register/')({
  component: RouteComponent,
  head: () => pageTitle('Caja'),
});

function RouteComponent() {
  const { hasClaim, isLoading: authLoading } = useAuth();
  const canRead = hasClaim('SELLS_READ');

  if (!authLoading && !canRead) {
    return <Navigate to='/' />;
  }

  return <CashRegisterPage />;
}
